import Sys from "@/sys";

export default class CheckMain {

    static handle(resp) {
        console.log(resp.state + resp.desc)
    }

    /**
     * 检查系统
     * @returns {{state: boolean, desc: string}}
     */
    static async checkSys() {
        let system = "操作系统 : " + Sys.getSysName() + " " + Sys.getEdition()
        let browser = "浏览器 : " + Sys.getBrowser()
        return {
            state: true,
            desc: system + " " + browser,
            sync: true
        }
    }



}